import axiosInstance from './axios.instance';
import { logger } from '@utils/logger';

class ApiService {
  async get(url, config = {}) {
    try {
      const response = await axiosInstance.get(url, config);
      return this.handleResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async post(url, data = {}, config = {}) {
    try {
      const response = await axiosInstance.post(url, data, config);
      return this.handleResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async put(url, data = {}, config = {}) {
    try {
      const response = await axiosInstance.put(url, data, config);
      return this.handleResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async patch(url, data = {}, config = {}) {
    try {
      const response = await axiosInstance.patch(url, data, config);
      return this.handleResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  async delete(url, config = {}) {
    try {
      const response = await axiosInstance.delete(url, config);
      return this.handleResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  handleResponse(response) {
    return {
      success: true,
      data: response.data,
      status: response.status,
      headers: response.headers,
    };
  }

  handleError(error) {
    const errorResponse = {
      success: false,
      message: error.message || 'An unexpected error occurred',
      status: error.response?.status,
      data: error.response?.data,
    };

    if (error.response) {
      errorResponse.message = error.response.data?.message || error.message;
      errorResponse.errors = error.response.data?.errors;
    } else if (error.request) {
      errorResponse.message = 'No response received from server';
    }

    logger.error('API Service Error:', errorResponse);
    throw errorResponse;
  }
}

export const apiService = new ApiService();
export default apiService;
